export default {
  form: {
    header: {
      label: 'Header',
      placeholder: 'Header',
    },
    qr_code_header: {
      label: 'UI box header',
      placeholder: 'UI box header',
    },
    qr_code_description: {
      label: 'UI box description',
      placeholder: 'UI box description',
    },
    tag_text: {
      label: 'Tag text',
      placeholder: 'NEW!',
    },
    footer: {
      label: 'Footer text',
      placeholder: 'Enter footer text',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Select URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Primary color',
    },
    background_color: {
      label: 'Background color',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Failed to load flyer',
  },
};
